import React from 'react';

import { Link } from 'react-router-dom';

import { Button } from '@pkg/components';

import { FTU_CONNECT_WALLET_ID, useOnboardTarget } from '@app/store/zustand';

import { Text, Title, Wrapper } from './EmptyState.style';

export interface EmptyStateProps {
    title: string;
    text?: string;
    buttonText?: string;
    onClick?: () => void;
    secondaryButtonText?: string;
    secondaryButtonUrl?: string;
}

export function EmptyState({
    title,
    text,
    buttonText,
    onClick,
    secondaryButtonText,
    secondaryButtonUrl,
}: EmptyStateProps) {
    const step5Ref = useOnboardTarget('ftu', 'Onboard-Ftu-Step-5');

    return (
        <Wrapper>
            <Title>{title}</Title>
            {text && <Text>{text}</Text>}

            {buttonText && (
                <Button ref={step5Ref} id={FTU_CONNECT_WALLET_ID} onClick={onClick}>
                    {buttonText}
                </Button>
            )}

            {secondaryButtonText && secondaryButtonUrl && <Link to={secondaryButtonUrl}>{secondaryButtonText}</Link>}
        </Wrapper>
    );
}
